import { AloDbFleet } from '@/models/alodb/AloDbFleet'
import { FleetTabs } from '@/models/ui/FleetTabs'
export class FleetUi {
    
    public fleet:AloDbFleet
    public tabsleft:FleetTabs
    public tabsright:FleetTabs
    public leftPanelWidth:string

    constructor({fleet = new AloDbFleet(), tabsleft = new FleetTabs(), tabsright = new FleetTabs(), leftPanelWidth = "50%"} = {}) {
        this.fleet = fleet
        this.tabsleft = tabsleft
        this.tabsright = tabsright
        this.leftPanelWidth = leftPanelWidth
    }
} 